"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIPO_GRUPO_NUM = void 0;
exports.TIPO_GRUPO_NUM = {
    SALIDA_VOZ: 1,
    ENTRADA_VOZ: 2,
    SALIDA_SMS: 3,
    ENTRADA_SMS: 4,
};
